// import $ from 'jquery';

export class moreDropdown {
	
		constructor() {
            const components = document.querySelectorAll('.c-moreDropdown');

            components.forEach(component => {
                const button = component.querySelector('.c-moreDropdown__button');
                const content = component.querySelector('.c-moreDropdown__content');

                const maxHeight = component.dataset.dropdownMaxHeight;

                button.addEventListener('click', () => {
                    component.classList.toggle('active');
                    if (content.style.maxHeight) {
                        content.style.maxHeight = null;
                    } else {
                        content.style.maxHeight = maxHeight;
                    }
                })
            })
		}
	
}

